import * as types from '@/generated'
import { HierarchicalFilterFragment } from '@/ux/HierarchicalFilter/HierarchicalFilter.generated'

export function buildFilterInputsFromHierarchical(filters: HierarchicalFilterFragment[]): types.FieldInput[] {
  const filterArrays = filters.flatMap((filter) => {
    const selections = filter.selection?.map((_selection, index) => {
      return {
        id: filter.id ? `${filter.id}-${index}` : 'no filter id at HierarchicalFilterContextLine126',
        tag: types.FieldTag.SelectField,
        selection: {
          value: _selection.value ?? '',
          label: _selection.label ?? '',
        },
      }
    }) as types.FieldInput[]
    const leafSelections = {
      id: filter.id ? `${filter.id}-${filter.selection?.length}` : 'no filter id at HierarchicalFilterContextLine126',
      tag: types.FieldTag.MultiSelectField,
      selections: filter.leafSelections?.map((it) => {
        return {
          value: it.value ?? '',
          label: it.label ?? '',
        }
      }),
    } as types.FieldInput
    if (filter.multiselectOnLeaf === true) {
      selections?.push(leafSelections)
    }
    return selections ?? []
  })
  return filterArrays
}
